import { BuilderTemplateId, LegacyAssetIdAndLayerId } from '../builderTemplate';
import { PublishedArtifactGroupId } from '../publishedArtifact';
import { SocketMessageEvent } from '../sockets/messages';
import { UploadId } from '../upload';
import { IPartialAuditDataController } from './audit';
import { JobFailure } from './job-failure';

export interface IPublishImageRequest<CD> {
    channelData: CD;
    uploadId: UploadId;
    auditData: IPartialAuditDataController;
}

/**
 * This was originally bad typing being shared between the front and backend.
 *
 * I've split it into two separate types so it looks terrible, but its correct.
 */
export interface PartialAuditDataGraphQLBackend {
    builderTemplateId: BuilderTemplateId;
    deviceId?: number | null;
    linkedAssetLibraryAssetIds: LegacyAssetIdAndLayerId[];
    plannerId?: string | null;
    publishedArtifactGroupId?: PublishedArtifactGroupId | null;
    scheduledPublishGroupId?: unknown;
}

export type PublishMultiImageRequestBackend<CD> = {
    artifactIds: string[];
    auditData: PartialAuditDataGraphQLBackend;
    channelData: CD;
    locationId: string;
    scheduledTime?: Date;
};

/**
 * This is bad, it should be only on the frontend.
 * Refactor too hard at this point.
 */
interface PartialAuditDataGraphQLFrontend {
    builderTemplateId: BuilderTemplateId;
    deviceId?: number | null;
    linkedAssetLibraryAssetIds: LegacyAssetIdAndLayerId[];
    plannerId?: string | null;
    publishedArtifactGroupId: PublishedArtifactGroupId | null;
    scheduledPublishGroupId: string | null;
}

export type PublishMultiImageRequest<CD> = {
    artifactIds: string[];
    auditData: PartialAuditDataGraphQLFrontend;
    channelData: CD;
    locationId: string;
    scheduledTime?: Date;
};

export interface IPublishImageResponse {
    executionId: string;
}

export const ImageProcessingPlannerCreatedEvent = new SocketMessageEvent<IPublishImageResponse>(
    'imageProcessingPlannerCreated',
);
export const ImageProcessingFinishedEvent = new SocketMessageEvent<IPublishImageResponse>('imageProcessJobFinished');
export const ImageProcessingFailedEvent = new SocketMessageEvent<JobFailure>('imageProcessJobFailed');
